module.exports = __webpack_public_path__ + "img/Dislike.1f2542ae.svg";